export default (carrouselSection) => {
  if (typeof window.tC?.event?.clickArrows === 'function') {
    window.tC.event.clickArrows(this, {
      carrouselSection,
    });
  }
};
